/* RAJ cart drawer: AJAX add-to-cart, drawer with checkout timer, phone buy bar. Vanilla, no dependencies. */
(function () {
  'use strict';
  var SECTION = 'raj-cart-drawer';
  var KEY = 'raj_cart_deadline';
  var root, body, dur = 90, lastFocus;

  function $(s, c) { return (c || document).querySelector(s); }
  function store(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) { return null; } }

  function toast(msg) {
    var t = $('.raj-toast');
    if (!t) { t = document.createElement('div'); t.className = 'raj-toast'; t.setAttribute('role', 'alert'); document.body.appendChild(t); }
    t.textContent = msg || 'Something went wrong. Please try again.';
    t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 3500);
  }

  /* ---------- timer ---------- */
  function deadline() { return parseInt(store(KEY), 10) || 0; }
  function resetDeadline() { store(KEY, String(Date.now() + dur * 1000)); }
  function tick() {
    if (!body) return;
    var el = body.querySelector('[data-raj-timer]'), box = body.querySelector('[data-raj-urgency]');
    if (!el || !box) return;
    var dl = deadline();
    if (!dl) { resetDeadline(); dl = deadline(); }
    var left = Math.max(0, Math.round((dl - Date.now()) / 1000));
    var m = Math.floor(left / 60), s = left % 60;
    el.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    var bar = body.querySelector('[data-raj-timer-bar]');
    if (bar) bar.style.width = Math.max(0, Math.min(100, (left / dur) * 100)) + '%';
    box.classList.toggle('is-low', left > 0 && left <= 30);
    box.classList.toggle('is-expired', left === 0);
  }

  /* ---------- confetti burst (canvas, no dependencies) ---------- */
  var lastBurst = 0;
  function confetti() {
    if (!root || !root.hasAttribute('data-confetti')) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var now = Date.now();
    if (now - lastBurst < 4000) return;
    lastBurst = now;
    var cv = document.createElement('canvas');
    cv.className = 'raj-confetti';
    cv.setAttribute('aria-hidden', 'true');
    document.body.appendChild(cv);
    var ctx = cv.getContext('2d'), dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = window.innerWidth, H = window.innerHeight;
    cv.width = W * dpr; cv.height = H * dpr; ctx.scale(dpr, dpr);
    var panel = $('.raj-cart__panel', root), pr = panel ? panel.getBoundingClientRect() : { left: 0, width: W };
    var left = Math.max(pr.left, 0), width = pr.width || W;
    var colours = ['#f2c66d', '#d4a24a', '#b08443', '#c8102e', '#2f6b2a', '#ffffff', '#1b1815'];
    var parts = [];
    function burst(x, y, dir) {
      for (var i = 0; i < 70; i++) {
        var a = (dir === 0 ? -Math.PI / 2 : dir < 0 ? -Math.PI / 3 : -2 * Math.PI / 3) + (Math.random() - 0.5) * 1.3;
        var v = 7 + Math.random() * 9;
        parts.push({ x: x, y: y, vx: Math.cos(a) * v, vy: Math.sin(a) * v, w: 6 + Math.random() * 6, h: 4 + Math.random() * 6, r: Math.random() * Math.PI, vr: (Math.random() - 0.5) * 0.35, c: colours[(Math.random() * colours.length) | 0], round: Math.random() < 0.25 });
      }
    }
    burst(left + width * 0.12, H * 0.34, -1);
    burst(left + width * 0.88, H * 0.34, 1);
    burst(left + width * 0.5, H * 0.24, 0);
    var t0 = performance.now();
    function frame(t) {
      var el = t - t0;
      ctx.clearRect(0, 0, W, H);
      var alive = 0;
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i];
        p.vy += 0.32; p.vx *= 0.985; p.vy *= 0.985;
        p.x += p.vx; p.y += p.vy; p.r += p.vr;
        if (p.y > H + 20) continue;
        alive++;
        ctx.save();
        ctx.globalAlpha = Math.max(0, 1 - el / 2200);
        ctx.translate(p.x, p.y); ctx.rotate(p.r);
        ctx.fillStyle = p.c;
        if (p.round) { ctx.beginPath(); ctx.arc(0, 0, p.w / 2.4, 0, Math.PI * 2); ctx.fill(); }
        else ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h * Math.abs(Math.cos(p.r * 2)) + 1);
        ctx.restore();
      }
      if (alive && el < 2400) requestAnimationFrame(frame); else cv.remove();
    }
    requestAnimationFrame(frame);
  }

  /* ---------- drawer ---------- */
  function count() {
    var c = body && body.querySelector('[data-raj-count]');
    if (!c) return;
    var n = c.getAttribute('data-raj-count');
    document.querySelectorAll('.sf-cart-count').forEach(function (e) { e.textContent = n; });
    if (n === '0') store(KEY, null);
  }
  function checkoutFallback() {
    setTimeout(function () {
      var ph = body && body.querySelector('.raj-cart__checkout .shiprocket-headless');
      var fb = body && body.querySelector('[data-raj-checkout-fallback]');
      if (ph && fb && ph.childElementCount === 0) fb.hidden = false;
    }, 1800);
  }
  function refresh() {
    return fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + '?sections=' + SECTION, { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var tmp = document.createElement('div');
        tmp.innerHTML = d[SECTION] || '';
        var nb = tmp.querySelector('[data-raj-cart-body]');
        if (nb && body) body.innerHTML = nb.innerHTML;
        count(); tick(); checkoutFallback();
      });
  }
  function open() {
    if (!root) return;
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('raj-cart-lock');
    tick();
    var p = $('.raj-cart__panel', root); if (p) p.focus({ preventScroll: true });
    setTimeout(confetti, 260);
  }
  function close() {
    if (!root) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('raj-cart-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  /* ---------- cart API ---------- */
  var busy = false;
  function add(form, btn) {
    if (!form || busy) return Promise.resolve();
    var fd = new FormData(form);
    if (!fd.get('id')) { toast('Please choose an option first.'); return Promise.resolve(); }
    busy = true;
    if (btn) btn.classList.add('is-loading');
    return fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.j.description || res.j.message); return; }
        resetDeadline();
        document.querySelectorAll('.sf-pqv__close, [data-quickview-close]').forEach(function (b) { try { b.click(); } catch (e) {} });
        open();
        return refresh();
      })
      .catch(function () { toast(); })
      .then(function () { busy = false; if (btn) btn.classList.remove('is-loading'); });
  }
  function addId(id, btn) {
    if (!id || busy) return Promise.resolve();
    busy = true;
    if (btn) btn.classList.add('is-loading');
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) toast(j.description || j.message); }); })
      .then(refresh)
      .catch(function () { toast(); })
      .then(function () { busy = false; if (btn) btn.classList.remove('is-loading'); });
  }
  function change(key, qty) {
    if (busy) return Promise.resolve();
    busy = true;
    body.classList.add('is-busy');
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) toast(j.description || j.message); }); })
      .then(refresh)
      .catch(function () { toast(); })
      .then(function () { busy = false; body.classList.remove('is-busy'); });
  }

  /* ---------- phone buy bar ---------- */
  function productForm() {
    var forms = [].slice.call(document.querySelectorAll('form.main-product, form[action*="/cart/add"]'));
    return forms.filter(function (f) { return !f.closest('.prod__sticky-atc') && !f.closest('[data-raj-cart]') && !f.closest('.raj-mbar'); })[0];
  }
  function initBar() {
    var bar = $('[data-raj-mbar]');
    if (!bar) return;
    document.body.classList.add('raj-has-mbar');
    var atc = $('[data-raj-mbar-atc]', bar), buy = $('[data-raj-mbar-buy]', bar), label = atc.querySelector('span');
    var initial = label.textContent;
    function mainAtc() { var f = productForm(); return f && f.querySelector('button[name="add"]'); }
    function sync() {
      var b = mainAtc(); if (!b) return;
      var off = b.disabled || b.hasAttribute('disabled');
      atc.disabled = off; buy.disabled = off;
      label.textContent = off ? 'Sold out' : initial;
      bar.classList.toggle('is-soldout', off);
    }
    var mb = mainAtc();
    if (mb) { sync(); if ('MutationObserver' in window) new MutationObserver(sync).observe(mb, { attributes: true, attributeFilter: ['disabled'] }); }
    atc.addEventListener('click', function () { add(productForm(), atc); });
    buy.addEventListener('click', function () {
      var f = productForm();
      var sr = (f && f.querySelector('.sr-headless-checkout')) || $('.sr-headless-checkout');
      if (sr) { sr.click(); return; }
      if (!f) return;
      buy.classList.add('is-loading');
      fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) })
        .then(function (r) { if (r.ok) { window.location.href = '/checkout'; } else { return r.json().then(function (j) { toast(j.description || j.message); }); } })
        .catch(function () { toast(); })
        .then(function () { buy.classList.remove('is-loading'); });
    });
  }

  /* ---------- wiring ---------- */
  function isAddForm(f) { return f && f.action && /\/cart\/add/.test(f.action) && !f.closest('[data-raj-noajax]'); }
  function bind() {
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var btn = t.closest('button[name="add"], button[type="submit"], input[type="submit"]');
      if (btn && isAddForm(btn.form) && !btn.disabled && !btn.closest('.raj-mbar')) {
        e.preventDefault(); e.stopImmediatePropagation();
        add(btn.form, btn);
        return;
      }
      var icon = t.closest('a.cart-icon');
      if (icon && window.location.pathname !== '/cart') {
        e.preventDefault(); e.stopImmediatePropagation();
        open(); refresh();
        return;
      }
      if (!root || !root.contains(t)) return;
      if (t.closest('[data-raj-cart-close]')) { e.preventDefault(); e.stopImmediatePropagation(); close(); return; }
      var q = t.closest('[data-raj-qty]');
      if (q) { e.preventDefault(); e.stopImmediatePropagation(); change(q.getAttribute('data-key'), parseInt(q.getAttribute('data-raj-qty'), 10)); return; }
      var ut = t.closest('[data-raj-utab]');
      if (ut) {
        e.preventDefault(); e.stopImmediatePropagation();
        var box = ut.closest('.raj-ups'), n = ut.getAttribute('data-raj-utab');
        box.querySelectorAll('[data-raj-utab]').forEach(function (b) { b.classList.toggle('is-active', b === ut); });
        box.querySelectorAll('[data-raj-upanel]').forEach(function (p) { p.hidden = p.getAttribute('data-raj-upanel') !== n; });
        return;
      }
      var ua = t.closest('[data-raj-upsell]');
      if (ua) { e.preventDefault(); e.stopImmediatePropagation(); addId(ua.getAttribute('data-raj-upsell'), ua); return; }
      if (t.closest('[data-raj-checkout-fallback]')) {
        if (window.shiprocketCheckoutEvents && window.shiprocketCheckoutEvents.buyCart) window.shiprocketCheckoutEvents.buyCart(e);
        else window.location.href = '/checkout';
      }
    }, true);
    document.addEventListener('submit', function (e) {
      if (!isAddForm(e.target)) return;
      e.preventDefault(); e.stopImmediatePropagation();
      add(e.target, e.target.querySelector('button[name="add"]'));
    }, true);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root && root.classList.contains('is-open')) close(); });
  }

  function init() {
    if (window.RAJCart) return;
    root = $('[data-raj-cart]');
    body = root && $('[data-raj-cart-body]', root);
    if (root) dur = parseInt(root.getAttribute('data-timer'), 10) || 90;
    window.RAJCart = { open: open, close: close, refresh: refresh, add: add };
    bind();
    initBar();
    setInterval(tick, 1000);
    checkoutFallback();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
